import {
    BooleanField,
    Datagrid,
    DateField,
    List,
    NumberField,
    TextField,
  } from 'react-admin';
  
  export const SettingsList = () => (
    <List>
      <Datagrid rowClick="edit">
        <NumberField source="id" />
        <DateField source="created_at" />
        <TextField source="web_notice" />
        <BooleanField source="web_notice_active" />
      </Datagrid>
    </List>
  );